<template>
  <div>
    <HEADER></HEADER>
    <!-- <div class="nc_join_header">
      <div class="banner">
        <img src="../assets/img/partner/nc_school.png" alt />
      </div>
      <div class="w">
        <div class="join_content">
          <h1>服务合作伙伴</h1>
          <p>具备ncompass产品或者服务的交付能力，</p>
          <p>能为客户提供完整的解决方案。具有规范的客户服务体系</p>
          <p>和专业的技术服务团队。</p>
        </div>
      </div>
    </div> -->
    <BANNER :src="banner_bg" h1='服务合作伙伴' >
      <p>具备nCompass产品或者服务的交付能力，能为客户提供完整的解决方案</p>
      <p>具有规范的客户服务体系和专业的技术服务团队</p>
    </BANNER>
    <div class="nc_support_main">
      <div class="w">
        <h1>合作伙伴赋能计划</h1>
        <div class="table">
          <div class="train">
            <div class="first">培训支持</div>
            <div class="box">
              <img src="../assets/img/support/cj.png" alt />
              <p>初级</p>
              <p>NC-101——NCP培训课程</p>
              <ul>
                <li>
                  <span class="circle"></span> 完成设备的安装调试能力
                </li>
                <li>
                  <span class="circle"></span> 完成标准的POC能力
                </li>
                <li>
                  <span class="circle"></span> 完成项目交付的第一阶段工作能力
                </li>
              </ul>
            </div>
            <div class="box">
              <img src="../assets/img/support/zj.png" alt />
              <p>中级</p>
              <p>NC-201——NCE培训课程</p>
              <ul>
                <li>
                  <span class="circle"></span> 完成项目整体交付能力
                </li>
                <li>
                  <span class="circle"></span> 应对大客户POC能力
                </li>
                <li>
                  <span class="circle"></span> 充分理解并传递nCompass数据价值的能力
                </li>
              </ul>
            </div>
            <div class="box">
              <img src="../assets/img/support/gj.png" alt />
              <p>高级</p>
              <p>NC-301——NCM培训课程</p>
              <ul>
                <li>
                  <span class="circle"></span> 利用nCompass数据解决日常运维过程中遇到疑难故障的能力
                </li>
                <li>
                  <span class="circle"></span> 及时响应上级对决策数据需求的能力
                </li>
              </ul>
            </div>
          </div>
          <div class="tech">
            <div class="first">技术支持</div>
            <div class="right">
              <img src="../assets/img/product/gouxuan.svg" alt /> 售前能力提升
              <img src="../assets/img/product/gouxuan.svg" alt /> 解决方案赋能
              <img src="../assets/img/product/gouxuan.svg" alt /> 行业案例分享
              <img src="../assets/img/product/gouxuan.svg" alt /> 项目支撑
              <img src="../assets/img/product/gouxuan.svg" alt /> 质量指导
              <img src="../assets/img/product/gouxuan.svg" alt /> 区域专属专家支持
            </div>
          </div>
          <div class="market">
            <div class="first">市场支持</div>
            <div class="right">
              <img src="../assets/img/product/gouxuan.svg" alt /> 认证培训授牌
              <img src="../assets/img/product/gouxuan.svg" alt /> 市场策略规划
              <img src="../assets/img/product/gouxuan.svg" alt /> 市场活动支持
              <img src="../assets/img/product/gouxuan.svg" alt /> nCompass官网展示宣传
              <img src="../assets/img/product/gouxuan.svg" alt /> 联合营销基金
            </div>
          </div>
          <div class="sell">
            <div class="first">销售支持</div>
            <div class="right">
              <img src="../assets/img/product/gouxuan.svg" alt /> 大客户服务项目共享
              <img src="../assets/img/product/gouxuan.svg" alt /> 项目机会挖掘
              <img src="../assets/img/product/gouxuan.svg" alt /> 销售能力提升
              <img src="../assets/img/product/gouxuan.svg" alt /> 行业合作计划
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
      <div class="w">
        <div class="contact">
          <div class="mail">
            <img src="../assets/img/about/mail.svg" alt />
            <div class="right">
              <p>技术支持</p>
              <p>support@ncmps.com</p>
            </div>
          </div>
          <div class="phone">
            <img src="../assets/img/about/phone.svg" alt />
            <div class="right">
              <p>全国免费客户服务热线</p>
              <p>400-666-8216</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <WHO></WHO>
    <FOOTER></FOOTER>
  </div>
</template>

<script>
import HEADER from "../components/header.vue";
import FOOTER from "../components/footer.vue";
import WHO from "../components/who.vue";
import BANNER from "../components/banner.vue";
import banner_bg from '../assets/img/support/nc_support.jpg';
export default {
  components: {
    HEADER,
    FOOTER,
    WHO,
    BANNER
  },
  data() {
    return {
      banner_bg:banner_bg
    };
  },
};
</script>

<style lang='less'>
@import url("../assets/css/join.less");
.nc_join_header .join_content p {
  margin-bottom: 8px;
}
.nc_support_main h1 {
  text-align: center;
  font-size: 24px;
  color: #6924ff;
  font-weight: normal;
  letter-spacing: 0.1em;
  margin: 50px 0 40px 0;
}
.nc_support_main .table {
  width: 100%;
  border: 1px solid #005dff;
  .train {
    width: 100%;
    height: 374px;
    display: flex;
    border-bottom: 1px solid #005dff;
    .box {
      flex: 1;
      border-right: 1px solid #005dff;
      p {
        text-align: center;
        margin-bottom: 10px;
      }
      img {
        margin: 40px auto 0;
        display: block;
      }
      ul {
        margin-top: 50px;
        li {
          position: relative;
          font-size: 14px;
          padding-left: 80px;
          line-height: 35px;
          padding-right: 10px;
        }
      }
    }
    .box:last-child {
      border-right: none;
    }
  }
  .first {
    width: 116px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid #005dff;
    height: 100%;
  }
  .tech,
  .market,
  .sell {
    width: 100%;
    height: 140px;
    display: flex;
    border-bottom: 1px solid #005dff;
    .left {
      width: 116px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #005dff;
    }
    .right {
      flex: 1;
      line-height: 140px;
      img {
        width: 14px;
        height: 14px;
        margin: 0 10px 0 40px;
      }
    }
  }
  .sell {
    border-bottom: none;
  }
}
.line {
  border-top: 1px solid #7683e5;
  margin-top: 54px;
}
.contact {
  width: 100%;
  display: flex;
  height: 110px;
  justify-content: space-evenly;
  align-items: center;
  padding: 0 20px;
  img {
    width: 54px;
    height: 54px;
    float: left;
  }
  .right {
    float: left;
    margin-left: 14px;
    p:nth-child(1) {
      margin-bottom: 14px;
    }
    p:nth-child(2) {
      color: #6924ff;
    }
  }
}
.circle {
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0076fd;
  vertical-align: middle;
  display: inline-block;
  top: 15px;
  left: 64px;
}
</style>